webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    formatPrice: function formatPrice(price) {
      return price.toFixed(2).replace('.', ',');
    }
  }
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Cart__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CartIndicator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProductList__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Cart: __WEBPACK_IMPORTED_MODULE_0__components_Cart__["a" /* default */],
    CartIndicator: __WEBPACK_IMPORTED_MODULE_1__components_CartIndicator__["a" /* default */],
    ProductList: __WEBPACK_IMPORTED_MODULE_2__components_ProductList__["a" /* default */]
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_price__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cart',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_price__["a" /* default */]],
  computed: {
    isOpen: function isOpen() {
      return this.$store.state.cartIsOpen;
    },
    productsAdded: function productsAdded() {
      return this.$store.state.productsAdded;
    },
    order: function order() {
      return this.$store.getters.order;
    },
    subtotal: function subtotal() {
      return this.$store.getters.subtotal;
    }
  },
  methods: {
    closeCart: function closeCart() {
      this.$store.commit('closeCart');
    },
    removeItem: function removeItem(id) {
      this.$store.commit('removeItem', id);
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_price__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cart-indicator',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_price__["a" /* default */]],
  computed: {
    quantity: function quantity() {
      return this.$store.getters.totalQuantity;
    },
    subtotal: function subtotal() {
      return this.$store.getters.subtotal;
    }
  },
  methods: {
    openCart: function openCart() {
      window.scrollTo(0, 0);
      this.$store.commit('openCart');
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Product__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product-list',
  components: {
    Product: __WEBPACK_IMPORTED_MODULE_0__components_Product__["a" /* default */]
  },
  computed: {
    products: function products() {
      return this.$store.state.products;
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MInputNumber__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_price__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_price__["a" /* default */]],
  props: ['currencyFormat', 'id', 'image', 'installments', 'price', 'title'],
  data: function data() {
    return {
      quantity: 1
    };
  },

  computed: {
    installmentPrice: function installmentPrice() {
      return this.price / this.installments;
    },
    imgSrc: function imgSrc() {
      return 'https://via.placeholder.com/220/' + this.image;
    }
  },
  methods: {
    addToCart: function addToCart() {
      var quantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.quantity, 10);
      if (quantity) {
        this.$store.commit('addToCart', {
          productId: this.id,
          quantity: quantity
        });
      }
    }
  },
  components: {
    MInputNumber: __WEBPACK_IMPORTED_MODULE_1__components_MInputNumber__["a" /* default */],
    MButton: __WEBPACK_IMPORTED_MODULE_2__components_MButton__["a" /* default */]
  }
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MButton__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      internalValue: 0
    };
  },

  methods: {
    decrement: function decrement() {
      if (!this.min || this.internalValue > this.min) {
        this.internalValue -= 1;
      }
    },
    increment: function increment() {
      if (!this.max || this.internalValue < this.max) {
        this.internalValue += 1;
      }
    }
  },
  mounted: function mounted() {
    this.internalValue = this.value;
  },

  watch: {
    internalValue: function internalValue() {
      this.$emit('input', this.internalValue);
    }
  },
  components: {
    MButton: __WEBPACK_IMPORTED_MODULE_0__components_MButton__["a" /* default */]
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MButton_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b30fdae6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MButton_vue__ = __webpack_require__(50);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b30fdae6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    emitClickEvent: function emitClickEvent(e) {
      this.$emit('click', e);
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(55);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */]
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d62b202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(54);
function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d62b202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b008c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(27);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b008c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"absolute pin-r pin-y w-full md:w-4/5 lg:w-3/5 bg-grey-darkest text-grey-lighter p-8 flex flex-col shadow-lg"},[_c('div',{staticClass:"relative mb-8"},[_c('img',{staticClass:"w-6 mr-4",attrs:{"src":__webpack_require__(10),"alt":"Carrinho"}}),_vm._v(" "),_c('h2',{staticClass:"uppercase font-normal tracking-wide inline-block"},[_vm._v("\n      Carrinho\n    ")]),_vm._v(" "),_c('button',{staticClass:"absolute pin-r",on:{"click":_vm.closeCart}},[_c('img',{staticClass:"w-6",attrs:{"src":__webpack_require__(28),"alt":"Fechar"}})])]),_vm._v(" "),(_vm.productsAdded.length)?_c('div',{staticClass:"flex-1"},[_c('table',{staticClass:"w-full text-sm md:text-base",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.order),function(item){return _c('tr',{key:item.product.id,staticClass:"h-24"},[_c('td',{staticClass:"w-24 hidden md:table-cell"},[_c('img',{attrs:{"src":("https://via.placeholder.com/50/" + (item.product.image)),"alt":"Thumbnail"}})]),_vm._v(" "),_c('td',[_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(item.product.title))]),_vm._v(" "),_c('button',{staticClass:"text-grey-lighter",on:{"click":function($event){_vm.removeItem(item.product.id)}}},[_c('small',[_vm._v("(Remover item)")])])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n            "+_vm._s(item.quantity)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-right hidden md:table-cell"},[_vm._v("\n            R$ "+_vm._s(_vm.formatPrice(item.product.price))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n            R$ "+_vm._s(_vm.formatPrice(item.product.price * item.quantity))+"\n          ")])])})),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"h-24"},[_c('td',{staticClass:"hidden md:table-cell"}),_vm._v(" "),_c('td',{staticClass:"border-t"}),_vm._v(" "),_c('td',{staticClass:"border-t hidden md:table-cell"}),_vm._v(" "),_c('th',{staticClass:"text-right border-t uppercase"},[_vm._v("Subtotal")]),_vm._v(" "),_c('td',{staticClass:"text-right border-t"},[_vm._v("\n            R$ "+_vm._s(_vm.formatPrice(_vm.subtotal))+"\n          ")])])])])]):_c('p',[_vm._v("\n    Seu carrinho está vazio.\n  ")])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"h-12 uppercase"},[_c('th',{staticClass:"hidden md:table-cell"}),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Produto")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('span',{staticClass:"lg:hidden",attrs:{"title":"Quantidade"}},[_vm._v("Qtd")]),_vm._v(" "),_c('span',{staticClass:"hidden lg:inline"},[_vm._v("Quantidade")])]),_vm._v(" "),_c('th',{staticClass:"text-right hidden md:table-cell"},[_vm._v("Preço unitário")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Preço total")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTEycHgiIHZlcnNpb249IjEuMSIgaGVpZ2h0PSI1MTJweCIgdmlld0JveD0iMCAwIDY0IDY0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NCA2NCI+CiAgPGc+CiAgICA8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMjguOTQxLDMxLjc4NkwwLjYxMyw2MC4xMTRjLTAuNzg3LDAuNzg3LTAuNzg3LDIuMDYyLDAsMi44NDljMC4zOTMsMC4zOTQsMC45MDksMC41OSwxLjQyNCwwLjU5ICAgYzAuNTE2LDAsMS4wMzEtMC4xOTYsMS40MjQtMC41OWwyOC41NDEtMjguNTQxbDI4LjU0MSwyOC41NDFjMC4zOTQsMC4zOTQsMC45MDksMC41OSwxLjQyNCwwLjU5YzAuNTE1LDAsMS4wMzEtMC4xOTYsMS40MjQtMC41OSAgIGMwLjc4Ny0wLjc4NywwLjc4Ny0yLjA2MiwwLTIuODQ5TDM1LjA2NCwzMS43ODZMNjMuNDEsMy40MzhjMC43ODctMC43ODcsMC43ODctMi4wNjIsMC0yLjg0OWMtMC43ODctMC43ODYtMi4wNjItMC43ODYtMi44NDgsMCAgIEwzMi4wMDMsMjkuMTVMMy40NDEsMC41OWMtMC43ODctMC43ODYtMi4wNjEtMC43ODYtMi44NDgsMGMtMC43ODcsMC43ODctMC43ODcsMi4wNjIsMCwyLjg0OUwyOC45NDEsMzEuNzg2eiIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartIndicator_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7f73f4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartIndicator_vue__ = __webpack_require__(30);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7f73f4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full flex p-2 pr-6"},[_c('div',{staticClass:"flex flex-col justify-center"},[_c('p',[_vm._v("Subtotal: R$ "+_vm._s(_vm.formatPrice(_vm.subtotal)))])]),_vm._v(" "),_c('div',{staticClass:"relative h-full"},[_c('button',{staticClass:"w-24 h-full text-grey-lighter -mr-6",on:{"click":_vm.openCart}},[_c('img',{staticClass:"w-10",attrs:{"src":__webpack_require__(10),"alt":"Carrinho"}}),_vm._v(" "),(_vm.quantity)?_c('span',{staticClass:"inline-block min-w-6 bg-red absolute pin-r pin-t rounded-full leading-normal"},[_vm._v("\n        "+_vm._s(_vm.quantity)+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ece11076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__ = __webpack_require__(53);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ece11076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ea6061c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__ = __webpack_require__(52);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ea6061c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MInputNumber_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305a3986_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MInputNumber_vue__ = __webpack_require__(51);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MInputNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305a3986_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MInputNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bg-indigo hover:bg-indigo-dark text-grey-lighter font-bold rounded",on:{"click":_vm.emitClickEvent}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex h-8"},[_c('m-button',{staticClass:"w-8 rounded-r-none",attrs:{"disabled":_vm.internalValue === _vm.min},on:{"click":function($event){$event.preventDefault();_vm.decrement($event)}}},[_vm._v("\n    -\n  ")]),_vm._v(" "),_c('input',{staticClass:"bg-grey-lighter w-8 text-center",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.internalValue}}),_vm._v(" "),_c('m-button',{staticClass:"w-8 rounded-l-none",attrs:{"disabled":_vm.internalValue === _vm.max},on:{"click":function($event){$event.preventDefault();_vm.increment($event)}}},[_vm._v("\n    +\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center md:w-1/3 p-4 leading-loose"},[_c('figure',[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"Product Image"}}),_vm._v(" "),_c('figcaption',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"w-12 mb-4 border-t-2 border-indigo"}),_vm._v(" "),_c('p',[_c('small',{staticClass:"text-grey-darker"},[_vm._v("R$")]),_vm._v(" "),_c('span',{staticClass:"text-xl font-semibold"},[_vm._v(_vm._s(_vm.formatPrice(_vm.price)))])]),_vm._v(" "),_c('p',{staticClass:"text-grey-darker"},[_vm._v("\n    ou "+_vm._s(_vm.installments)+" x "),_c('small',[_vm._v("R$")]),_vm._v(" "),_c('span',{staticClass:"font-semibold"},[_vm._v("\n       "+_vm._s(_vm.formatPrice(_vm.installmentPrice))+"\n    ")])]),_vm._v(" "),_c('p',[_vm._v("Quantidade:\n    "),_c('m-input-number',{attrs:{"min":1,"max":10},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"my-2"},[_c('m-button',{staticClass:"py-2 px-4",on:{"click":_vm.addToCart}},[_vm._v("\n      Adicionar ao carrinho\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex flex-wrap justify-center sm:justify-start bg-grey-lightest"},_vm._l((_vm.products),function(product){return _c('product',_vm._b({key:product.id},'product',product,false))}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-grey-darkest relative",attrs:{"id":"app"}},[_c('header',{staticClass:"w-full h-16 bg-indigo text-grey-lighter flex justify-between fixed pin-t"},[_c('div',{staticClass:"pl-4 flex items-center uppercase"},[_vm._v("Shopping Cart")]),_vm._v(" "),_c('cart-indicator')],1),_vm._v(" "),_c('main',{staticClass:"container mx-auto px-4 pt-20"},[_c('product-list'),_vm._v(" "),_c('cart')],1),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w-full p-8 leading-loose"},[_c('div',{staticClass:"md:text-center text-sm mb-8"},[_vm._v("\n      Made by Marcus Tenório • "),_c('a',{attrs:{"href":"https://github.com/mvtenorio/shopping-cart"}},[_vm._v("Github")])]),_vm._v(" "),_c('div',{staticClass:"md:text-right text-xs"},[_c('div',[_vm._v("Icon made by "),_c('a',{attrs:{"href":"https://www.flaticon.com/authors/gregor-cresnar","target":"_blank","title":"Gregor Cresnar"}},[_vm._v("Gregor Cresnar")]),_vm._v(" from "),_c('a',{attrs:{"href":"https://www.flaticon.com/","target":"_blank","title":"Flaticon"}},[_vm._v("www.flaticon.com")]),_vm._v(" is licensed by "),_c('a',{attrs:{"href":"http://creativecommons.org/licenses/by/3.0/","title":"Creative Commons BY 3.0","target":"_blank"}},[_vm._v("CC 3.0 BY")])]),_vm._v(" "),_c('div',[_vm._v("Icon made by "),_c('a',{attrs:{"href":"https://www.flaticon.com/authors/hadrien","target":"_blank","title":"Hadrien"}},[_vm._v("Hadrien")]),_vm._v(" from "),_c('a',{attrs:{"href":"https://www.flaticon.com/","target":"_blank","title":"Flaticon"}},[_vm._v("www.flaticon.com")]),_vm._v(" is licensed by "),_c('a',{attrs:{"href":"http://creativecommons.org/licenses/by/3.0/","title":"Creative Commons BY 3.0","target":"_blank"}},[_vm._v("CC 3.0 BY")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */
/* unused harmony export getters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_products_json__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_products_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_products_json__);
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  cartIsOpen: false,
  products: __WEBPACK_IMPORTED_MODULE_2__data_products_json__["products"],
  productsAdded: []
};

var mutations = {
  addToCart: function addToCart(state, _ref) {
    var productId = _ref.productId,
        quantity = _ref.quantity;

    var product = state.productsAdded.find(function (item) {
      return item.productId === productId;
    });

    if (product) {
      product.quantity += quantity;
      return;
    }
    state.productsAdded.push({
      productId: productId,
      quantity: quantity
    });
  },
  removeItem: function removeItem(state, productId) {
    var indexToRemove = state.productsAdded.findIndex(function (item) {
      return item.productId === productId;
    });
    state.productsAdded.splice(indexToRemove, 1);
  },
  openCart: function openCart(state) {
    state.cartIsOpen = true;
  },
  closeCart: function closeCart(state) {
    state.cartIsOpen = false;
  }
};

var getters = {
  order: function order(state) {
    function createOrderItem(item) {
      return {
        quantity: item.quantity,
        product: state.products.find(function (p) {
          return p.id === item.productId;
        })
      };
    }

    return state.productsAdded.map(function (item) {
      return createOrderItem(item);
    });
  },
  totalQuantity: function totalQuantity(state) {
    return state.productsAdded.reduce(function (previous, current) {
      return previous + current.quantity;
    }, 0);
  },
  subtotal: function subtotal(state) {
    return state.productsAdded.reduce(function (previous, current) {
      var price = state.products.find(function (item) {
        return item.id === current.productId;
      }).price;
      var totalPrice = price * current.quantity;
      return previous + totalPrice;
    }, 0);
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

module.exports = {"products":[{"id":1,"title":"Produto A","description":"Modelo A","price":229.9,"installments":4,"isFreeShipping":true,"image":"1abc9c"},{"id":2,"title":"Produto B","description":"Modelo B","price":199.9,"installments":3,"isFreeShipping":true,"image":"2980b9"},{"id":3,"title":"Produto C","description":"Modelo C","price":29.9,"installments":2,"isFreeShipping":true,"image":"9b59b6"},{"id":4,"title":"Produto D","description":"Modelo D","price":429.9,"installments":4,"isFreeShipping":true,"image":"e74c3c"},{"id":5,"title":"Produto E","description":"Modelo E","price":369.9,"installments":3,"isFreeShipping":true,"image":"f1c40f"},{"id":6,"title":"Produto F","description":"Modelo F","price":929.9,"installments":12,"isFreeShipping":true,"image":"bdc3c7"}]}

/***/ })
],[19]);


// WEBPACK FOOTER //
// static/js/app.dc30b229e3c13f91a5ec.js